import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    document.title = 'Privacy Policy - Golden Crown Hotels';
  }, []);

  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <h1 className="mb-4">Privacy Policy</h1>
      <p className="text-muted mb-4">Last updated: February 18, 2026</p>

      <section className="mb-4">
        <h2>1. Introduction</h2>
        <p>
          Golden Crown Hotels ("we," "our," or "us") operates the Guest Experience Platform (GCXP). 
          This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
          when you use our Service.
        </p>
      </section>

      <section className="mb-4">
        <h2>2. Information We Collect</h2>
        <h3>2.1 Personal Information</h3>
        <p>We may collect the following personal information:</p>
        <ul>
          <li>Name and contact information (phone number, email)</li>
          <li>Room number and booking details</li>
          <li>Language preferences</li>
          <li>Service requests and order history</li>
          <li>Messages sent through the platform</li>
        </ul>
        
        <h3>2.2 Technical Information</h3>
        <p>We automatically collect:</p>
        <ul>
          <li>Device information and browser type</li>
          <li>IP address and location data</li>
          <li>Usage data and interaction logs</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>3. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and maintain our Service</li>
          <li>Process your service requests and orders</li>
          <li>Send you notifications about your requests</li>
          <li>Communicate with you via WhatsApp, SMS, or the platform</li>
          <li>Improve our Service and guest experience</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>4. WhatsApp Integration</h2>
        <p>
          Our Service integrates with WhatsApp to provide convenient communication. 
          When you interact with us via WhatsApp:
        </p>
        <ul>
          <li>Your phone number and messages are processed through Meta's WhatsApp Business API</li>
          <li>Message content is used solely to respond to your inquiries and service requests</li>
          <li>We do not sell or share your WhatsApp data with third parties for marketing purposes</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>5. Data Retention</h2>
        <p>
          We retain your personal information for the duration of your hotel stay and for a 
          reasonable period afterward to handle any follow-up matters. Service request records 
          may be retained for up to 12 months for quality assurance purposes.
        </p>
      </section>

      <section className="mb-4">
        <h2>6. Data Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your 
          personal information against unauthorized access, alteration, disclosure, or 
          destruction. This includes encryption, secure servers, and access controls.
        </p>
      </section>

      <section className="mb-4">
        <h2>7. Third-Party Services</h2>
        <p>We may use third-party services including:</p>
        <ul>
          <li>Meta WhatsApp Business API for messaging</li>
          <li>Microsoft Azure for hosting and data storage</li>
          <li>SMS providers for verification codes</li>
        </ul>
        <p>These providers have their own privacy policies governing their use of data.</p>
      </section>

      <section className="mb-4">
        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt out of marketing communications</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>9. Data Deletion</h2>
        <p>
          To request deletion of your personal data, please visit our{' '}
          <a href="/legal/data-deletion">Data Deletion page</a> or contact us at the 
          email address below.
        </p>
      </section>

      <section className="mb-4">
        <h2>10. Contact Us</h2>
        <p>
          For questions about this Privacy Policy or to exercise your rights, contact us at:<br />
          Email: privacy@goldencrown.co.il
        </p>
      </section>
    </div>
  );
}
